import styled from '@emotion/styled'

import { CardContent } from 'components/Card/Card.style'

const cardContentAdjustment = `
  ${CardContent} {
    display: flex;
    padding: 10px 20px;
    width: 100%;
  }
`
export const HistoryItemHeader = styled.div`
  display: flex;
  align-content: center;
  flex-direction: row;
  button {
    margin-left: 5px;
  }
`
export const HistoryItemContent = styled.div`
  margin: 10px -20px;
  margin-bottom: 20px;
  z-index: 10;
  ${cardContentAdjustment}
`
